import { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
	const [cartItems, setCartItems] = useState([]);

	useEffect(() => {
		const savedCartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
		setCartItems(savedCartItems);
	}, []);

	const addItemToCart = (item) => {
		const updatedCartItems = [...cartItems, item];
		setCartItems(updatedCartItems);
		localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
	};

	const removeItemFromCart = (indexToRemove) => {
		const updatedCartItems = cartItems.filter(
			(_, index) => index !== indexToRemove
		);
		setCartItems(updatedCartItems);
		localStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
	};

	return (
		<CartContext.Provider
			value={{ cartItems, addItemToCart, removeItemFromCart }}
		>
			{children}
		</CartContext.Provider>
	);
};

CartProvider.propTypes = {
	children: PropTypes.node.isRequired,
};